import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["creditsSelect"]
  static values = {
    pricePerPackCents: Number
  }

  declare creditsSelectTarget: HTMLSelectElement
  declare pricePerPackCentsValue: number

  connect() {
    this.dispatchQuantityChanged()
  }

  onChange() {
    this.dispatchQuantityChanged()
  }

  private dispatchQuantityChanged() {
    const credits = parseInt(this.creditsSelectTarget.value, 10) || 0
    const multiplier = credits + 1
    const selectedCredits = this.selectedCreditsQuantity
    const totalCents = multiplier * this.pricePerPackCentsValue
    const totalFormatted = this.formatDollars(totalCents)

    this.dispatch("quantityChanged", {
      detail: {
        credits,
        quantity: multiplier,
        lineLabel: `${selectedCredits} Extra voter credits`,
        totalCents,
        totalFormatted,
        linePriceFormatted: `$${totalFormatted}`
      },
      bubbles: true
    })
  }

  private formatDollars(cents: number): string {
    return (cents / 100).toFixed(2)
  }

  private get selectedCreditsQuantity(): number {
    const optionText = this.creditsSelectTarget.selectedOptions?.[0]?.text
    return parseInt(optionText || "0", 10) || 0
  }
}